import { httpCreate } from './http';

const http = httpCreate('/srv/guessQuestion');

export const guessQuestion = {
	//新增问题
	addQue(data) {
		return http.post('', data);
	},
	//修改问题
	updateQue(id, data) {
		return http.put(`/${id}`, data);
	},
	//获取问题详情
	getDetail(id) {
		return http.get(`/${id}`);
	},
	//删除问题
	delQue(id) {
		return http.delete(`/${id}`);
	},
	//获取分页列表
	getList(params) {
		return http.get('/list', { params });
	},
	//获取问题下拉列表
	getDownList(params) {
		return http.get('/myList', { params });
	}
};
